export const vacationsData=[
    {
        img:"./images_vacations/france.jpg",
        title:"Feel the Romance in France",
        name:"France"
        
    },
    {
        img:"./images_vacations/maldives.jpg",
        title:"Are you even a couple if you haven't planned a trip to Maldives?"
        ,name:"Maldives"
    },
    {
        img:"./images_vacations/italy.webp",
        title:"Enjoy the world class food in Italy"
        ,name:"Italy"
    },
    {
        img:"./images_vacations/hawai.jpg",
        title:"Pictures in those leave-shorts are mandatory in Hawaii"
        ,name:"Hawaii"
    },
    {
        img:"./images_vacations/greece.webp",
        title:"Look at the marvel of human architecture in Greece"
        ,name:"Greece"
    },
    {
        img:"./images_vacations/lasvegas.jpg",
        title:"Ready to shell some money in Las-Vegas ?"
        ,name:"Las Vegas"
        // title:"Gambling in Las-Vegas is subjected to market risk. Please read all scheme related documents carefully!"
    },
    
]